<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

@if (personPhones != null && personId != null) {
  <div class="phone_edit">
    <p-table #pt [value]="personPhones" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="personPhoneId"
      selectionMode="single" [(selection)]="personPhone" (onRowSelect)="onRowSelect($event)"
      [loading]="loading" responsiveLayout="scroll">
      <ng-template pTemplate="caption">
        <div align="right" class="btn-group">
          @if (personId != null) {
            <button mat-raised-button class="btn-upt p-button" pButton pRipple (click)="onOpenFormAdd()">Add Phone +</button>
          }
          @if (personId == null) {
            <button mat-raised-button class="btn-upt p-button" color="primary" (click)="onOpenFormAdd()">Add Phone +</button>
          }
        </div>
      </ng-template>
      @if (personPhones.length > 0 && personPhones != null) {
        <ng-template pTemplate="header" >
          <tr>
            @for (col of columns; track col) {
              <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
                {{col.header}}
              </th>
            }
            <th [ngStyle]="{'width': 'auto'}"></th>
          </tr>
        </ng-template>
      }
      <ng-template pTemplate="body" let-personPhone>
        <tr [pSelectableRow]="personPhone">
          <td>{{personPhone.personPhoneId}} </td>
          <td>{{getPhoneType(personPhone)}}</td>
          <td>{{personPhone.countryCode}}</td>
          <td>{{personPhone.phoneNum}}</td>
          <!--<td>{{personAddress.personId}}</td>-->
          <td><span style="float:none">
            <a>
              <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
              (click)="onOpenFormEdit(personPhone)">edit</mat-icon>
            </a>
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
}
@if (personPhones == null && personId != null) {
  <div>
    <p-table #pt [value]="personPhones" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="personPhoneId"
      selectionMode="single" [(selection)]="personPhone" (onRowSelect)="onRowSelect($event)"
      [loading]="loading" responsiveLayout="scroll">
      <ng-template pTemplate="caption">
        <div align="right">
          @if (personId != null) {
            <button mat-raised-button class="p-button-text" pButton pRipple (click)="onOpenFormAdd()">Add Phone +</button>
          }
          @if (personId == null) {
            <button mat-raised-button color="primary" (click)="onOpenFormAdd()">Add Phone +</button>
          }
        </div>
      </ng-template>
    </p-table>
  </div>
}
@if (personPhones == null && personId == null) {
  <div>
    <p-table #pt [value]="personPhones" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="personPhoneId"
      selectionMode="single" [(selection)]="personPhone" (onRowSelect)="onRowSelect($event)"
      [loading]="loading" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
      currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
      sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
      [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
      <ng-template pTemplate="caption"> <i class="fa fa-search" style="margin:4px 4px 0 0;"></i>
      <div class="d-block text-end">
        <span>
          <!--clear filters-->
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
          <!--add new-->
          @if (personId != null) {
            <button pButton pRipple class="p-button-text" style="padding: 0.643rem 0.75rem !important;"
            (click)="onOpenFormAdd()">New Phone +</button>
          }
          @if (personId == null) {
            <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
            (click)="onOpenFormAdd()">New Phone +</button>
          }
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        }
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'personPhoneId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'type', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'countryCode', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'phoneNum', 'in')"></th>
        <!--<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'personVO.personId', 'in')"></th>-->
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-personPhone>
      <tr [pSelectableRow]="personPhone">
        <td>{{personPhone.personPhoneId}} </td>
        <td>{{getPhoneType(personPhone)}}</td>
        <td>{{personPhone.countryCode}}</td>
        <td>{{personPhone.phoneNum}}</td>
        <!--<td>{{personAddress.personId}}</td>-->
        <td><span style="float:none">
          <a>
            <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
            (click)="onOpenFormEdit(personPhone)">edit</mat-icon>
          </a>
        </span>
      </td>
    </tr>
  </ng-template>
</p-table>
</div>
}

@if (personPhones != null && personId == null) {
  <div>
    <p-table #pt [value]="personPhones" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="personPhoneId"
      selectionMode="single" [(selection)]="personPhone" (onRowSelect)="onRowSelect($event)"
      [loading]="loading" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
      currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
      sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
      [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
      <ng-template pTemplate="caption"> <i class="fa fa-search" style="margin:4px 4px 0 0;"></i>
      <div class="d-block text-end">
        <span>
          <!--clear filters-->
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
          <!--add new-->
          @if (personId != null) {
            <button pButton pRipple class="p-button-text" style="padding: 0.643rem 0.75rem !important;"
            (click)="onOpenFormAdd()">New Phone +</button>
          }
          @if (personId == null) {
            <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
            (click)="onOpenFormAdd()">New Phone +</button>
          }
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        }
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'personPhoneId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'type', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'countryCode', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'phoneNum', 'in')"></th>
        <!--<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'personVO.personId', 'in')"></th>-->
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-personPhone>
      <tr [pSelectableRow]="personPhone">
        <td>{{personPhone.personPhoneId}} </td>
        <td>{{getPhoneType(personPhone)}}</td>
        <td>{{personPhone.countryCode}}</td>
        <td>{{personPhone.phoneNum}}</td>
        <!--<td>{{personAddress.personId}}</td>-->
        <td><span style="float:none">
          <a>
            <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
            (click)="onOpenFormEdit(personPhone)">edit</mat-icon>
          </a>
        </span>
      </td>
    </tr>
  </ng-template>
</p-table>
</div>
}